    (function($) {

        var wow = new WOW(
      {
        //mobile: false
    }
    )
    wow.init();

	$(window).on('scroll',function(){
		var scrollTop = $(this).scrollTop();

		if(scrollTop >= 150  && !$('header.header>.header-inner').hasClass('scrolled-header')) {
			$('header.header>.header-inner').addClass('scrolled-header');
            //$('.header .button').addClass('secondary-button');
            //$(this).scrollTop(151);

		}

		else if(scrollTop <= 149 && $('header.header>.header-inner').hasClass('scrolled-header')) {
			$('header.header>.header-inner').removeClass('scrolled-header');
            //$('.header .button').removeClass('secondary-button');
            //$(this).scrollTop(148);

		}
	});

	$(document).ready(function(){
		  $('.projects-preview-slider').slick({
		    infinite: true,
		    arrows: false,
		    slidesToShow: 1,
		    autoplay: true,
		    //appendArrows: $('.projects-preview-arrows'),
		    fade: true,
            pauseOnFocus: false,
            pauseOnHover: false,
		  });

		   $('.partner-logos-slider').slick({
		    infinite: true,
		    arrows: false,
		    slidesToShow: 3,
		    autoplay: true,
            autoplaySpeed: 0,
            speed: 2000,
		    dots: false,
		   responsive: [
		    {
		      breakpoint: 768,
		      settings: {
		        slidesToShow: 2,
		        centerMode: true,
		      }
		    },

             {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                centerMode: true,
              }
            },
		    ],
		  });

        $('.posts-slider').slick({
            infinite: false,
            arrows: true,
            slidesToShow: 4,
            autoplay: true,
            dots: true,
            appendArrows: $('#posts-arrow-container'),
           responsive: [
            {
              breakpoint: 1100,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 2,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '20px',
              }
            },
            ],
          });
         var contents_slider = function($selector, $slides) {

        var slider = $($selector).find('.contents-slider'),
            slider_prev = $($selector).find('.content-prev'),
            slider_next = $($selector).find('.content-next'),
            slides = $slides,
            slides_res = slides - 1;

            //console.log(typeof $slides);

         $(slider).slick({
            infinite: false,
            arrows: true,
            slidesToShow: slides,
            autoplay: false,
            autoplaySpeed: 3000,
            dots: false,
            prevArrow: slider_prev,
            nextArrow: slider_next,
           responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: slides_res,
              }
            },
            {
              breakpoint: 900,
              settings: {
                slidesToShow: 1,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1,
                centerMode: true,
                centerPadding: '20px',
              }
            },
            ],
          });
        }

        $('.contents-slider-outer').each(function(){
            contents_slider(this, 2);
        });

        contents_slider('.testimonials-section',1);
        contents_slider('.contents-slider-outer-letters',3);

            //This option is for pages with a slider of images
    var lightbox = new SimpleLightbox('.image-gallery>.single-image>a', { /* options */ });
    var lightboxGrid = new SimpleLightbox('.image-gallery-grid>.single-image>a', { /* options */ });
    

    var windowWidth = $(window).width();

        if(windowWidth > 1170) {
            var centerPadAmount = (windowWidth - 1170) / 2;
        }

        else {
            var centerPadAmount = 20;
        }

        var lightboxGall = new SimpleLightbox('.image-gallery-extra>.single-image>a', { /* options */ });

        var gallerySlider = function($selector) { 

        var galleryArrows = $($selector).siblings('.gallery-arrows');
            
        $($selector).slick({
          arrows: true,
          infinite: true,
          speed: 300,
          slidesToShow: 2,
          autoplay:true,
          initialSlide: 0,
          centerMode: true,
          centerPadding: centerPadAmount + 'px',
          appendArrows: galleryArrows,
          //asNavFor: '.image-gallery',
          fade: false,
        responsive: [
            {
              breakpoint: 769,
              settings: {
                slidesToShow: 1,
              }
            },
            {
              breakpoint: 480,
              settings: {
                arrows: true,
                slidesToShow: 1,
              }
            }
            ],
        });
        }

        //gallerySlider('.image-gallery-header-slider');

        var imageGalleryExtra = $('.image-gallery-extra');

        $(imageGalleryExtra).each(function(){
            gallerySlider(this);
        });

        //This will create a lightbox gallery to replace the default wordpress gallery
         var galleryItems = $('figure.wp-block-gallery figure.wp-block-image');

          galleryItems.each(function() {
          
          var   caption = $(this).find( "figcaption" ),
                captionText = $(caption).text(),
                link = $(this).find( "a" ),
                image = $(this).find( "img" );
          $(image).attr('title', captionText);


          });
           // Galleries on Project Pages

           if($('figure.wp-block-gallery').length > 0) {
              var lightbox = new SimpleLightbox('figure.wp-block-gallery figure.wp-block-image a', {
                // captionSelector : 'figcaption',
                // captionType : 'text'
              });
            }
	});

//open and close search menu
$('button.search-toggle').on("click", function (event) {
    event.preventDefault();
    $('body').toggleClass('search-open');
    event.stopPropagation();
});

$(document).bind('keydown', function(e) {
	//alert(e.which);
    if (e.which == 27) {
        $('body').removeClass('search-open');
    }
}); 

/**
 * initMap
 *
 * Renders a Google Map onto the selected jQuery element
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @return  object The map instance.
 */
function initMap( $el ) {

    // Find marker elements within map.
    var $markers = $el.find('.marker');

    // Create gerenic map.
    var mapArgs = {
        zoom        : $el.data('zoom') || 16,
        mapTypeId   : google.maps.MapTypeId.ROADMAP
    };
    var map = new google.maps.Map( $el[0], mapArgs );

    // Add markers.
    map.markers = [];
    $markers.each(function(){
        initMarker( $(this), map );
    });

    // Center map based on markers.
    centerMap( map );

    // Return map instance.
    return map;
}

/**
 * initMarker
 *
 * Creates a marker for the given jQuery element and map.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   jQuery $el The jQuery element.
 * @param   object The map instance.
 * @return  object The marker instance.
 */
function initMarker( $marker, map ) {

    // Get position from marker.
    var lat = $marker.data('lat');
    var lng = $marker.data('lng');
    var latLng = {
        lat: parseFloat( lat ),
        lng: parseFloat( lng )
    };

    // Create marker instance.
    var marker = new google.maps.Marker({
        position : latLng,
        map: map
    });

    // Append to reference for later use.
    map.markers.push( marker );

    // If marker contains HTML, add it to an infoWindow.
    if( $marker.html() ){

        // Create info window.
        var infowindow = new google.maps.InfoWindow({
            content: $marker.html()
        });

        // Show info window when marker is clicked.
        google.maps.event.addListener(marker, 'click', function() {
            infowindow.open( map, marker );
        });
    }
}

/**
 * centerMap
 *
 * Centers the map showing all markers in view.
 *
 * @date    22/10/19
 * @since   5.8.6
 *
 * @param   object The map instance.
 * @return  void
 */
function centerMap( map ) {

    // Create map boundaries from all map markers.
    var bounds = new google.maps.LatLngBounds();
    map.markers.forEach(function( marker ){
        bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
        });
    });

    // Case: Single marker.
    if( map.markers.length == 1 ){
        map.setCenter( bounds.getCenter() );

    // Case: Multiple markers.
    } else{
        map.fitBounds( bounds );
    }
}

// Render maps on page load.
$(document).ready(function(){
    $('.acf-map').each(function(){
        var map = initMap( $(this) );
    });
});


    $(window).on('load',function() {        
        // Animate loader off screen
        $("#loader").fadeOut(100);
    });

//animate all anchor links

document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
    });
});

    var resizeItem = function($selector) {
        var itemSize = 0;

        $($selector).each(function(i){
                if($(this).innerHeight() > itemSize) {
                    itemSize = $(this).innerHeight();
                }
        })

        $($selector).css('height',itemSize + 'px');
           
        };

    $(window).on('load',function(){
        resizeItem('.page-link-contents');
        resizeItem('.tour-card__title');
    });

})( jQuery );